import React, { useState, useEffect, useRef } from "react";
import AppointmentsService from "services/appointments.service";
import ChatSessionService from "services/chat-session.service";
import AuthService from "services/auth.service";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { parseDate } from "react-day-picker/moment";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close.svg";
import CalendarIcon from "assets/icons/Calendar 2.svg";
import ButtonCalendarIcon from "assets/icons/Calendar-icon.svg";
import ClockIcon from "assets/icons/Clock.svg";
import Spinner from "react-bootstrap/Spinner";
import { standardDate } from "helpers/common.helper";
import { getBodyParts } from "helpers/teleconsult.helper";
import Select from "react-select";
import moment from "moment";
import "react-day-picker/lib/style.css";

function ScheduleFollowUpModal({ details }) {
  const formatDate = (date) => {
    return moment(date).format("DD-MM-YYYY");
  };
  const isClosed = useRef(false);
  const showFollowUpBtn = details.video_session || details.is_premium_plus;
  const [disabledFollowUpBtn, setdisabledFollowUpBtn] = useState(false);
  const showVideoCreditRemaining = details.is_premium_plus;
  const [showSuccess, setShowSuccess] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [appointmentDate, setAppointmentDate] = useState(
    formatDate(new Date())
  );
  const [slots, setSlots] = useState([]);
  const [slot, setSlot] = useState({});
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [isSlotDisabled, setIsSlotDisabled] = useState(false);

  const handleClose = () => {
    setShow(false);
    setShowSuccess(false);
    setAppointmentDate(formatDate(new Date()));
  };

  const setSlotLabel = (slot) => {
    return (
      moment.unix(slot.start - slot.offset).format("hh:mm a") +
      " - " +
      moment.unix(slot.end - slot.offset).format("hh:mm a")
    );
  };

  useEffect(() => {
    setIsSlotDisabled(true);
    setSlot({});

    if (details.is_premium_plus && details?.video_credit_remaining <= 0) {
      setdisabledFollowUpBtn(true);
    }
    const parameters = {
      location: AuthService.getPracticeLocation().id,
      date: moment(appointmentDate, "DD-MM-YYYY").format("YYYYMMDD"),
    };
    AppointmentsService.slots(parameters)
      .then(
        (data) => {
          setError(
            data.length === 0
              ? "Selected date has no available time slots"
              : null
          );
          var _slots = [];
          if (data.length > 0) {
            _slots = data.map((slot) => {
              return {
                value: slot,
                label: setSlotLabel(slot),
              };
            });
          }
          setSlots(_slots);
          setIsSlotDisabled(false);
        },
        (error) => {
          console.log(error.response);

          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        // loader
      });

    return () => {
      isClosed.current = true;
    };
  }, [appointmentDate]); // eslint-disable-line react-hooks/exhaustive-deps

  const InfoRows = (arr) => {
    const byChunks = arr.reduce(
      (memo, value, index) => {
        if (index % 2 === 0 && index !== 0) memo.push([]);
        memo[memo.length - 1].push(value);
        return memo;
      },
      [[]]
    );

    return byChunks.map((array, index) => {
      return (
        <div className="row" key={index}>
          <div className="col">
            <p className="text-lightgrey mb-0 font-size-3">{array[0]?.title}</p>
            <p>
              <b>{array[0]?.value || "-"}</b>
            </p>
          </div>

          <div className="col">
            <p className="text-lightgrey mb-0 font-size-3">{array[1]?.title}</p>
            <p>
              <b>{array[1] ? array[1]?.value || "-" : null}</b>
            </p>
          </div>
        </div>
      );
    });
  };

  const PatientRows = () => {
    const user = details?.user || details?.user_info;
    const gender = user?.gender || user?.sex;
    const employer =
      details?.employee_info?.employer_name || user?.corporate?.name || "N/A";
    const description =
      details?.chat_session?.description || details?.description;
    const body_part = details?.chat_session?.body_part || details?.body_part;

    const patientInfo = [
      { title: "First Name", value: user?.first_name },
      { title: "Last Name", value: user?.last_name },
      { title: "Date Of Birth", value: standardDate(user?.date_of_birth) },
      { title: "Gender", value: gender },
      { title: "Email", value: user?.email },
      { title: "Phone", value: user?.phone },
      { title: "Employer", value: employer },
      { title: "Specialty Required For", value: getBodyParts(body_part) },
      { title: "Health Problem", value: description },
    ];

    return InfoRows(patientInfo);
  };

  const AppointmentForm = () => {
    return (
      <div>
        <div className="d-flex">
          <div className="daypicker-container mr-3">
            <img
              src={CalendarIcon}
              alt="calendar-icon"
              className="calendar-icon"
            />
            <DayPickerInput
              parseDate={parseDate}
              format={"DD-MM-yyyy"}
              name="start_date"
              value={appointmentDate}
              onDayChange={(e) => {
                setAppointmentDate(formatDate(e));
              }}
            />
          </div>
          <div className="daypicker-container">
            {isSlotDisabled ? (
              <div className="loader conditional-display calendar-icon">
              <Spinner animation="border" className="spinner"/>
            </div>
            ) : (<img src={ClockIcon} alt="clock-icon" className="calendar-icon" />)}
            
            <Select
              options={slots}
              placeholder=""
              className="react-select slot-select"
              value={slots.filter((option) => option.value === slot)}
              onChange={(e) => {
                setSlot(e.value);
              }}
              isDisabled={isSlotDisabled}
            />
          </div>
        </div>
        {error && <div className="text-danger small pt-1">{error}</div>}
      </div>
    );
  };

  const AppointmentDetails = () => {
    const appointmentInfo = [
      { title: "Date", value: appointmentDate },
      { title: "Time", value: setSlotLabel(slot) },
    ];

    return InfoRows(appointmentInfo);
  };

  const handleSubmit = () => {
    if (Object.keys(slot).length !== 0) {
      setLoader(true);
      const params = {
        chat_session_id: details?.chat_session?.id || details.id,
        end_time: slot.end,
        start_time: slot.start,
        video_session_id: details?.video_session?.id,
      };

      if (details?.is_premium_plus) {
        ChatSessionService.createVideoSession(params)
          .then(
            (data) => {
              setShowSuccess(true);
            },
            (error) => {
              console.log(error.response);

              if (error.response.status === 401) {
                AuthService.logout();
                window.location.replace("/eb/login");
              }
              if (error.response.status === 422) {
                alert(error.response.data?.errors);
                handleClose();
              }
            }
          )
          .then(() => {
            setLoader(false);
          });
      } else {
        ChatSessionService.bookVideoSession(params)
          .then(
            (data) => {
              setShowSuccess(true);
            },
            (error) => {
              console.log(error.response);

              if (error.response.status === 401) {
                AuthService.logout();
                window.location.replace("/eb/login");
              }
            }
          )
          .then(() => {
            setLoader(false);
          });
      }
    }
  };

  const RemainingCredit = (params) => {
    const credit =
      params.type === "mental"
        ? details?.mental_video_credit_remaining
        : details?.video_credit_remaining;
    switch (credit) {
      case 0:
        return <div className="fw-300">No session left</div>;
      case null:
        return <div className="fw-300">Unlimited sessions left</div>;
      default:
        return <div className="fw-300">{credit} sessions left</div>;
    }
  };

  const ScheduleButtonText = () => {
    if (details.is_premium_plus === true) {
      return "Schedule Video Session";
    }
    if (!details.hasStarted) {
      return "Reschedule Session";
    } else {
      return "Schedule Follow Up Session";
    }
  };

  const VideoCreditRemainingBadge = () => {
    return (
      <div className="d-flex justify-content-center">
        <div className="badge credit-remaining">
          {details?.video_credit_remaining === 0 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M5.47415 0C2.45575 0 0 2.4673 0 5.5C0 8.5327 2.4673 11 5.5 11C8.5327 11 11 8.5327 11 5.5C11 2.4673 8.52115 0 5.47415 0ZM6.05 8.25H4.95V7.15H6.05V8.25ZM6.05 6.05H4.95V2.75H6.05V6.05Z"
                fill="#EB2726"
              />
            </svg>
          )}
          {details?.is_premium_plus && details?.is_mental_health_session ? (
            <div className="fw-600">Mental Health Coach:</div>
          ) : (
            <div className="fw-600">Health Coach:</div>
          )}

          <RemainingCredit
            type={
              details?.is_premium_plus && details?.is_mental_health_session
                ? "mental"
                : ""
            }
          />
        </div>
      </div>
    );
  };
  return (
    <>
      {showFollowUpBtn && (
        <button
          className="btn schedule-btn"
          onClick={handleShow}
          disabled={disabledFollowUpBtn}
        >
          <img src={ButtonCalendarIcon} alt="calendar-icon" />
          <ScheduleButtonText />
        </button>
      )}

      <Modal
        className="health-info-modal"
        size="lg"
        backdrop="static"
        show={show}
        onHide={handleClose}
      >
        <div
          className="loader conditional-display"
          displayed={loader.toString()}
        >
          <Spinner animation="border" className="spinner" />
        </div>
        <div className="conditional-display" displayed={(!loader).toString()}>
          <Modal.Header>
            <Modal.Title className="w-100 text-center modal-title">
              {showSuccess ? "Appointment Details" : "Schedule Appointment"}
              {showVideoCreditRemaining && <VideoCreditRemainingBadge />}
            </Modal.Title>
            <button type="button" className="close" onClick={handleClose}>
              <img src={CloseBtn} alt="modal-close" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="row d-flex align-items-center m-0">
              <h5 className="pt-2 mr-2 ">Teleconsult (Video Call)</h5>
            </div>
            <h6 className="pt-3 pb-2">Date & Time</h6>
            {!showSuccess && <AppointmentForm />}
            {showSuccess && <AppointmentDetails />}
            <hr />
            <h6 className="pt-3 pb-2">Patient Information</h6>
            <PatientRows />
            <div
              className="text-center mt-5 conditional-display"
              displayed={(!showSuccess).toString()}
            >
              <button
                className="btn rounded-pill w-em-26 btn-danger py-3"
                onClick={handleSubmit}
                disabled={Object.keys(slot).length === 0}
                displayed="false"
              >
                Create Appointment
              </button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
}

export default ScheduleFollowUpModal;
